var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWarning = function SvgWarning(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#105880",
    d: "m10.18 2 8.17 16H2l8.18-16Zm0 3.26L4.43 16.52h11.5L10.18 5.26Zm-.74 9.78v-1.48h1.48v1.48H9.44Zm0-6.52h1.48v1.78l-.3 2.37h-.89l-.3-2.37V8.52Z"
  })));
};
export default SvgWarning;